'use strict';
import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import Moneda from './Formulario/Moneda'
import Importe from './Formulario/Importe'
import FechaValor from './Formulario/FechaValor'
import Referencia from './Formulario/Referencia'

class Formulario extends PureComponent {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.limpiar = this.limpiar.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        const { accion, aceptar, form, ingresoCobranza } = this.props;
        form.validateFields((err, fieldsValue) => {
            if (!err) {
                let cobranza;
                if (accion == "guardar") {
                    cobranza = {
                        EntidadBancoEmisorId: null,
                        SucursalId: ingresoCobranza.sucursalId,
                        CuentaTarjetaId: ingresoCobranza.cuentaTarjetaId,
                        CuentaTarjetaSaldoId: null,
                        FechaCreacion: new Date(),
                        FechaCobranza: null,
                        FechaPresentacion: fieldsValue.fechaValor,
                        FechaCierre: null,
                        FechaProcesadoAdintar: null,
                        FechaProcesoAdministradora: null,
                        FechaCambioEstado: new Date(),
                        CobranzaEstadoId: ingresoCobranza.cobranzaEstadoId,
                        CobranzaMonedaId: fieldsValue.moneda,
                        Importe: fieldsValue.importe,
                        CobranzaOrigenId: ingresoCobranza.cobranzaOrigenId,
                        CobranzaModoIngreso: null,
                        FormaPagoId: ingresoCobranza.formaPagoId,
                        CargadoPorAdministradora: null,
                        CobranzaCarteraId: null,
                        FechaInformaEmerix: null,
                        NumeroReferencia: fieldsValue.referencia
                    };
                }
                else {
                    cobranza = {
                        FechaPresentacion: fieldsValue.fechaValor,
                        FechaCambioEstado: new Date(),
                        CobranzaEstadoId: ingresoCobranza.cobranzaEstadoId,
                        CobranzaMonedaId: fieldsValue.moneda,
                        Importe: fieldsValue.importe,
                        NumeroReferencia: fieldsValue.referencia
                    };
                }

                aceptar(cobranza, accion, form.resetFields);
            }
        });
    }

    limpiar() {
        const { limpiar, form } = this.props;
        form.resetFields();
        limpiar();
    }

    render() {
        const { ingresoCobranza, form, seleccionarMoneda, changeImporte, changeReferencia, changeDate } = this.props;
        const { getFieldDecorator } = form;

        return (
            <form onSubmit={this.handleSubmit} id="frmCobranza" name="Formulario" className="" method="POST">
                <div className="row top-separator-xs">

                    <div className="col-xs-12">

                        <h3>Ingresar Cobranzas</h3>

                        <Moneda tipoMoneda={ingresoCobranza.tipoMoneda}
                            monedaId={ingresoCobranza.monedaId}
                            form={form}
                            seleccionarMoneda={seleccionarMoneda} />

                        <Importe ingresoCobranza={ingresoCobranza}
                            changeImporte={changeImporte}
                            form={this.props.form} />

                        <FechaValor ingresoCobranza={ingresoCobranza}
                            changeDate={changeDate}
                            form={this.props.form} />

                        <Referencia ingresoCobranza={ingresoCobranza}
                            changeReferencia={changeReferencia}
                            form={this.props.form} />

                        <div className="row top-separator-xs">
                            <div className="col-xs-3">
                                <button type="submit" className="btn btn-secondary">Aceptar</button>
                            </div>
                            <div className="col-xs-3">
                                <button type="button" className="btn btn-secondary" onClick={this.limpiar}>Cancelar</button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        )
    }
}

export default createForm()(Formulario);